import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import demologonew from "../../assets/images/demologonew.svg";
import feedbacklogonew from "../../assets/images/feedbacklogonew.svg";
import FeedbackModal from "./FeedbackForm"; // Import the FeedbackModal
import ContactForm from "./ContactFom"; // Import the ContactForm
interface FeedbackProps {
  handleStartOver: any;
}

const Feedback: React.FC<FeedbackProps> = ({
  handleStartOver,
}) => {
  const [open, setOpen] = useState(false); // State to manage modal visibility
  const [Demo, setDemo] = useState(false);

  const handleFeedbackClick = () => {
    setOpen(true); // Open the modal when the button is clicked
  };
  const handleDemoClick = () => {
    setDemo(true); // Open the modal when the button is clicked
  };

  const handleClose = () => {
    setOpen(false); // Close the modal
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const handleDemoClose = () => {
    setDemo(false); // Close the modal 
  }

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 5 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "white",
          marginBottom: "40px",
          display: isMobile ? "flex" : "none",
        }}
      >
        Before you go...
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {/* Feedback Card */}
        <Grid item xs={12} sm={6} md={5}>
          <Card
            sx={{
              backgroundColor: "#0B1437",
              color: "white",
              textAlign: "center",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid rgba(66, 73, 101, 1)",
            }}
          >
            <CardContent>
              <Box
                component="img"
                src={feedbacklogonew}
                alt="Feedback Logo"
                sx={{
                  width: 50,
                  height: 50,
                  backgroundColor: "#1A237E",
                  borderRadius: "50%",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              />
              <Typography variant="body1" sx={{ marginBottom: 2 }}>
                We’d love to hear about your experience with playground.
              </Typography>
              <Button
                variant="outlined"
                sx={{
                  fontSize: "16px",
                  color: "#0073FF", // Blue text
                  borderRadius: "50px", // Rounded shape
                  border: "1px solid #0073FF",
                  backgroundColor: "white",
                  textTransform: "none", // Keep text as given
                  fontWeight: "700",
                  padding: "8px 24px",
                  "&:hover": {
                    backgroundColor: "#F0F4FF", // Light blue hover effect
                    borderColor: "#005FCC",
                  },
                }}
                onClick={handleFeedbackClick} // Open modal on click
              >
                Feedback
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Demo Card */}
        <Grid item xs={12} sm={6} md={5}>
          <Card
            sx={{
              backgroundColor: "#0B1437",
              color: "white",
              textAlign: "center",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid rgba(66, 73, 101, 1)",
            }}
          >
            <CardContent>
              <Box
                component="img"
                src={demologonew}
                alt="Demo Logo"
                sx={{
                  width: 50,
                  height: 50,
                  backgroundColor: "#1A237E",
                  borderRadius: "50%",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              />
               <Typography variant="body1" sx={{ marginBottom: 2 }}>
                Want to see the complete suite of features in action?
              </Typography>
              <Button
              onClick={handleDemoClick}
                variant="outlined"
                sx={{
                  fontSize: "16px",
                  color: "#0073FF", // Blue text
                  borderRadius: "50px", // Rounded shape
                  border: "1px solid #0073FF",
                  backgroundColor: "white",
                  textTransform: "none", // Keep text as given
                  fontWeight: "700",
                  padding: "8px 24px",
                  "&:hover": {
                    backgroundColor: "#F0F4FF", // Light blue hover effect
                    borderColor: "#005FCC",
                  },
                }}
              >
                Book a Demo
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Start Over Button */}
        <Grid item xs={12} md={12} sx={{ mt: 2 }} display="flex" justifyContent="center">
        <Button
          type="submit"
          variant="contained"
          sx={{
            display: isMobile ? "flex" : "block",
            marginBottom: "20px",
            backgroundColor: "#007BFF",
            borderRadius: "30px",
            px: 4,
            py: 1.5,
            fontSize: "14px",
            fontWeight: "700",
            color: "white",
            textTransform: "none",
            "&:hover": { backgroundColor: "#0056b3" },
          }}
          onClick={handleStartOver}
        >
          Start Over
        </Button>
        </Grid>
      </Grid>

      {/* Start Over Button */}
      <Box >
       
      </Box>

      {/* FeedbackModal with open state passed as prop */}
      <FeedbackModal open={open} onClose={handleClose} />
      <ContactForm open={Demo} onClose={handleDemoClose} />
    </Container>
  );
};

export default Feedback;
